import type { ReactNode } from 'react'
import { AlertTriangle } from 'lucide-react'

interface ConvertedRecordBannerProps {
  /** What this record became, and why edits here don't reach the client. */
  description: string
  /** Link to the downstream record that edits should be made on instead. */
  action?: ReactNode
}

/**
 * Warns that a record has already been converted into a downstream one
 * (quote → invoice, lead → event) and that edits here no longer propagate.
 *
 * The downstream record is snapshotted at conversion time, so edits made to
 * the upstream record after that point are silently invisible to the client.
 */
export function ConvertedRecordBanner({ description, action }: ConvertedRecordBannerProps) {
  return (
    <div className="rounded-lg border border-status-warning-border bg-status-warning-bg/60 px-4 py-3">
      <div className="flex items-start gap-3">
        <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-status-warning-fg" />
        <p className="text-sm text-status-warning-fg">
          {description}
          {action ? <> {action}</> : null}
        </p>
      </div>
    </div>
  )
}
